export enum NavigationPaths {
  LOGIN = '/login',
  RESET_PASSWORD = '/reset-password',
  NEW_PASSWORD = '/new-password',
  CONFIRMATION = '/confirmation-code',
  ORGANISATION_USERS = '/organisation-users',
  NOT_FOUND = '/not-found',
}
